'use strict';

(function () {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	const fadeEls = document.querySelectorAll('.fade-in');
	if (prefersReducedMotion) {
		fadeEls.forEach((el) => el.classList.add('visible'));
	} else {
		fadeEls.forEach((el) => {
			const delay = el.getAttribute('data-delay');
			if (delay) el.style.transitionDelay = `${delay}ms`;
		});
		const observer = new IntersectionObserver(
			(entries, obs) => {
				for (const entry of entries) {
					if (entry.isIntersecting) {
						entry.target.classList.add('visible');
						obs.unobserve(entry.target);
					}
				}
			},
			{ threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
		);
		fadeEls.forEach((el) => observer.observe(el));
	}

	const form = document.getElementById('form');
	if (!form) return;

	const nameInput = document.getElementById('name-input');
	const emailInput = document.getElementById('email-input');
	const messageInput = document.getElementById('message-input');
	const nameError = document.getElementById('name-error');
	const emailError = document.getElementById('email-error');
	const messageError = document.getElementById('message-error');
	const submitButton = document.getElementById('submit-btn');

	function isEmail(value) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
	}

	function setFieldState(inputWrap, state) {
		if (!inputWrap) return;
		inputWrap.classList.remove('input--error', 'input--valid');
		if (state === 'error') {
			inputWrap.classList.add('input--error');
		} else if (state === 'valid') {
			inputWrap.classList.add('input--valid');
		}
	}

	function validateName() {
		const v = nameInput.value.trim();
		if (!v) {
			nameError.textContent = 'Please enter your name.';
			setFieldState(nameInput.closest('.input'), 'error');
			nameInput.setAttribute('aria-invalid', 'true');
			return false;
		}
		nameError.textContent = '';
		setFieldState(nameInput.closest('.input'), 'valid');
		nameInput.setAttribute('aria-invalid', 'false');
		return true;
	}

	function validateEmail() {
		const v = emailInput.value.trim();
		if (!v) {
			emailError.textContent = 'Please enter your email.';
			setFieldState(emailInput.closest('.input'), 'error');
			emailInput.setAttribute('aria-invalid', 'true');
			return false;
		}
		if (!isEmail(v)) {
			emailError.textContent = 'Please enter a valid email address.';
			setFieldState(emailInput.closest('.input'), 'error');
			emailInput.setAttribute('aria-invalid', 'true');
			return false;
		}
		emailError.textContent = '';
		setFieldState(emailInput.closest('.input'), 'valid');
		emailInput.setAttribute('aria-invalid', 'false');
		return true;
	}

	function validateMessage() {
		const v = messageInput.value.trim();
		if (!v) {
			messageError.textContent = 'Please enter a message.';
			setFieldState(messageInput.closest('.input'), 'error');
			messageInput.setAttribute('aria-invalid', 'true');
			return false;
		}
		messageError.textContent = '';
		setFieldState(messageInput.closest('.input'), 'valid');
		messageInput.setAttribute('aria-invalid', 'false');
		return true;
	}

	nameInput.addEventListener('blur', validateName);
	nameInput.addEventListener('input', () => {
		if (nameInput.value.trim()) validateName();
		else {
			nameError.textContent = '';
			setFieldState(nameInput.closest('.input'), null);
		}
	});

	emailInput.addEventListener('blur', validateEmail);
	emailInput.addEventListener('input', () => {
		if (emailInput.value.trim()) validateEmail();
		else {
			emailError.textContent = '';
			setFieldState(emailInput.closest('.input'), null);
		}
	});

	messageInput.addEventListener('blur', validateMessage);
	messageInput.addEventListener('input', () => {
		if (messageInput.value.trim()) validateMessage();
		else {
			messageError.textContent = '';
			setFieldState(messageInput.closest('.input'), null);
		}
	});

	form.addEventListener('submit', (event) => {
		const okName = validateName();
		const okEmail = validateEmail();
		const okMsg = validateMessage();
		if (!okName || !okEmail || !okMsg) {
			event.preventDefault();
			if (!okName) nameInput.focus();
			else if (!okEmail) emailInput.focus();
			else messageInput.focus();
			return;
		}
		if (submitButton) submitButton.disabled = true;
	});
})();
